import React from 'react';

import { PostStats } from '../../Stats';

import style from './PopularPostCard.scss';

import cn from 'classnames';
import { Link } from 'gatsby';

export interface IPopularPostCard {
  id: string;
  slug: string;
  title: string;
  feature_image: string;
  featured: boolean;
  primary_author: {
    name: string;
    profile_image: string;
  };
  published_at: string;
}

export const PopularPostCard = ({ post }: { post: IPopularPostCard }) => {
  const { slug, title, published_at, primary_author, feature_image } = post;
  const url = `/${slug}/`;

  return (
    <Link to={url} className={style.base}>
      <div>
        <div className={style.headerContent}>
          <span className={cn('h4', style.title)}>{title}</span>
        </div>
        <PostStats publishedAt={published_at} author={primary_author ? primary_author.name : ''} />
      </div>
      <div className={style.imageWrapper}>
        <img height={98} width={98} className="lazy" data-src={feature_image} alt="" />
      </div>
    </Link>
  );
};
